import { useState, Dispatch, SetStateAction } from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';

import logo from '../../../assets/icon.svg';

import { useAtom } from 'jotai';

import { pageAtom } from '../../../atoms';
import { ENV_CONFIG, VERSION } from '../../../constant';
import { PAGE } from '../../../constant/page';
import ENVIRONMENT from '../../../constant/environment';

import TopconectLogo from '../../../sharedComponents/customImage';
import AccountInfoModal from '../accountInfoModal';

const AccountModalButton = (props: {
  setIsAccountModalOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const { setIsAccountModalOpen } = props;

  return (
    <Typography
      sx={{ cursor: 'pointer' }}
      variant='body1'
      onClick={() => {
        setIsAccountModalOpen(true);
      }}
    >
      アカウント情報
    </Typography>
  );
};

const LogoutButton = () => {
  const [, setPage] = useAtom(pageAtom);

  return (
    <Typography
      sx={{ cursor: 'pointer' }}
      variant='body1'
      onClick={() => {
        setPage(PAGE.LOGIN);
      }}
    >
      ログアウト
    </Typography>
  );
};

const Header = () => {
  const [page] = useAtom(pageAtom);
  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);

  const headerContent =
    page === PAGE.MAIN ? (
      <Box display={'flex'} flexDirection={'row'} columnGap={5}>
        <AccountModalButton setIsAccountModalOpen={setIsAccountModalOpen} />
        <LogoutButton />
      </Box>
    ) : (
      <></>
    );

  let title = 'Topconect Web';
  if (ENV_CONFIG !== ENVIRONMENT.PROD) {
    title += ' ' + VERSION + ' ' + ENV_CONFIG;
  }

  return (
    <AppBar
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      position='fixed'
    >
      <Toolbar sx={{ backgroundColor: '#007DC5' }}>
        <TopconectLogo src={logo} alt='title' width={30} height={30} />
        <Typography variant='h6' sx={{ flexGrow: 1 }}>
          {title}
        </Typography>
        {headerContent}
      </Toolbar>
      <AccountInfoModal
        isAccountModalOpen={isAccountModalOpen}
        setIsAccountModalOpen={setIsAccountModalOpen}
      />
    </AppBar>
  );
};

export default Header;
